/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TToggleOfferSliderModel,
  IToggleOfferSliderRequest,
  IMappers,
  IToggleOfferSliderResponse,
  IToggleOfferSliderResponseError,
  TToggleOfferSliderResponse,
} from './types';

const defaultConfig: TToggleOfferSliderModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'countryside-contracts-admin',
  pathApi: '/v1/toggle-offer-slider/',
  hostType: 'api',
} as TToggleOfferSliderModel;

function createToggleOfferSliderModel(parameters: IToggleOfferSliderRequest): TToggleOfferSliderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IToggleOfferSliderOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IToggleOfferSliderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchToggleOfferSlider<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IToggleOfferSliderOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TToggleOfferSliderResponse
> {
  const { response, statusCode } = await httpApi.fetch(createToggleOfferSliderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IToggleOfferSliderResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IToggleOfferSliderResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TToggleOfferSliderResponse;
}

export { defaultConfig, createToggleOfferSliderModel, fetchToggleOfferSlider };
